// Zobrist 哈希 — 14 棋类型 (7 types × 2 colors) × 90 格 + 1 side-to-move
// 参考文档: https://www.chessprogramming.org/Zobrist_Hashing
// JS Number 精度 53 位, 这里使用两个 32 位 (hi/lo) 拼接表示 64 位 — 用 string 返回以便 Map<key> 索引

import { Color, GameState, PieceType, NUM_SQUARES } from '../game/types';

// 14 棋类型索引: 0..6 红方 K,A,B,N,R,C,P; 7..13 黑方同
export const PIECE_INDEX: Record<string, number> = {};
{
  const types: PieceType[] = ['K', 'A', 'B', 'N', 'R', 'C', 'P'];
  let idx = 0;
  for (const t of types) { PIECE_INDEX['r' + t] = idx++; }
  for (const t of types) { PIECE_INDEX['b' + t] = idx++; }
}
// 共 14 * 90 = 1260 + 1 side = 1261 random numbers

// 用确定性 PRNG (mulberry32) 保证 key 稳定
function mulberry32(seed: number): () => number {
  return () => {
    seed = (seed + 0x6D2B79F5) | 0;
    let t = seed;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0);
  };
}

const rand = mulberry32(0x1234abcd);
const KEYS_HI: number[] = new Array(1261);
const KEYS_LO: number[] = new Array(1261);
for (let i = 0; i < 1261; i++) {
  KEYS_HI[i] = rand();
  KEYS_LO[i] = rand();
}

function pieceKeyIdx(color: Color, type: PieceType): number {
  return PIECE_INDEX[color + type];
}

// 计算整个局面的 Zobrist 键 (字符串 "hi:lo", 可用于 Map 键)
export function computeHash(state: GameState): string {
  let hi = 0, lo = 0;
  for (let sq = 0; sq < NUM_SQUARES; sq++) {
    const p = state.board[sq];
    if (!p) continue;
    const idx = pieceKeyIdx(p.color, p.type) * 90 + sq;
    hi ^= KEYS_HI[idx];
    lo ^= KEYS_LO[idx];
  }
  // side-to-move: 索引 1260
  if (state.turn === 'b') {
    hi ^= KEYS_HI[1260];
    lo ^= KEYS_LO[1260];
  }
  return `${hi >>> 0}:${lo >>> 0}`;
}

// 防御性: 也提供增量更新 (可选, Phase 1 不强制使用)
export function xorInto(hi: number, lo: number, idx: number): { hi: number; lo: number } {
  return { hi: (hi ^ KEYS_HI[idx]) >>> 0, lo: (lo ^ KEYS_LO[idx]) >>> 0 };
}
